import { useState } from 'react';
import { useDataProvider } from 'react-admin';

const limitToCall = 200;

const useContactDataProvider = props => {
  const dataProvider = useDataProvider();
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [errorUsers, setErrorUsers] = useState(null);
  const [fetchedUsers, setFetchedUsers] = useState(null);
  const { userIdList } = props;

  const isLoaded = fetchedUsers !== null;

  if (userIdList.length > 0 && !isLoadingUsers && !isLoaded && !errorUsers) {
    setIsLoadingUsers(true);

    let payload;
    if (userIdList.length <= limitToCall) {
      payload = {
        filter: {
          id: `[${userIdList}]`,
          orderBy: 'email',
          orderDirection: 'ASC'
        }
      };
    } else {
      payload = {
        filter: {
          orderBy: 'email',
          orderDirection: 'ASC'
        }
      };
    }
    dataProvider
      .getList('users', payload)
      .then(({ data }) => {
        let newUsers;
        if (userIdList.length > limitToCall) {
          newUsers = data.filter(item => userIdList.includes(item.userId));
        } else {
          newUsers = data;
        }
        setFetchedUsers(newUsers);
        setIsLoadingUsers(false);
      })
      .catch(error => {
        setErrorUsers(error);
        setIsLoadingUsers(false);
      });
  }

  return {
    fetchedUsers: {
      loading: isLoadingUsers,
      data: fetchedUsers || [],
      error: errorUsers
    },
    userIdList
  };
};

export default useContactDataProvider;
